/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-extraneous-dependencies
*/
import React from 'react';
import classnames from 'classnames';
import './progress-bar.scss';

export default function ProgressBar({ progressPercent }) {
  return (
    <div className={classnames('progress-bar', { 'progress-bar--success': progressPercent === 100 })} >
      <div
        className="progress-bar__percent"
        style={{ width: `${progressPercent}%` }} />
    </div>
  );
}
